<template>
	<div>
		<div id="tabs">
			<div 
				:class="{'tab':true,'selected':selectedTab==='article'}"
				@click="selectedTab='article'">
					Makaleler
			</div>
			
			<div 
				:class="{'tab':true,'selected':selectedTab==='report'}"
				@click="selectedTab='report'">
					Bildiriler
			</div>
		</div>

		<ul>
			<a 
				:href="essay.link"
				v-for="(essay, index) in selectedTab==='article'?list.article:list.report"
				:key="index"
				target="_blank">
					<li class="item">
						<h2>{{essay.title}}</h2>
						<span class="tag">{{essay.writers}}</span><br>
						<span class="tag">Yayın Yeri: {{essay.publisher}}</span><br>
						<span class="tag">{{essay.publishYear}}</span>
						<span class="tag">{{essay.nationality}}</span>
						<span v-if="essay.typeOfReport" class="tag">
							{{essay.typeOfReport}}
						</span>
						<span v-if="essay.digitization" class="tag">
							{{essay.digitization}}
						</span>
						<img
							src="../../public/icons/ExternalLink.svg"
							width="40px"
							alt="Eğer bu ikon mevcut ise bu öge ilgili makale/bildiri linkine yönlendirilmiştir"
							v-if="essay.link">
					</li>
			</a>
		</ul>
	</div>
</template>
<script>
	const firebase = require('firebase/app');

	export default {
		name: 'MyPublish',
		created(){
			firebase.database().ref('/MyPublishItems').once('value').then((snapshot) => {
				this.list = snapshot.val(); 
			});
		},
		data() {
			return {
				selectedTab: 'article',
				list: {},
			};
		},
	}
</script>

<style lang="scss" scoped>
	li{ list-style: none;}
	a[href='']{cursor: default;}
	a:not([href='']){cursor: pointer;}

	.tag {
		padding: 0.7em 1em;
		margin: 3% .8%;

		@media screen and (max-width: 768px){
			margin: 2% .8%;
			padding: 1em;
		}

		@media screen and (min-width: 768px){
			margin: 1% .8%;
		}
	}

	#tabs{
		display: flex;
		height: auto;
		width: fit-content;
		flex-direction: row;
		margin-top: 1em;
		margin-left: auto;
		margin-right: auto;

		.tab{
			padding: 20px;
			margin-left: 1em;
			margin-right: 1em;
			width: 20vw;
			z-index: 3;
			position: relative;
			
			display: flex;
			align-self: center;
			justify-content: center;

			border-radius: 30px;

			background-color: white;
			color: #333;
			box-shadow: 0 3px 6px #333;
			// filter: drop-shadow(0 3px 6px #333);
			transform: scale3d(1, 1, 1);
			transition: all 1s;

			@media screen and (max-width: 1024px){
				font-size: .8em;
			}

			@media screen and (max-width: 768px){
				font-size: .7em;
			}

			@media screen and (max-width: 425px){
				font-size: .5em;
			}
		
			&:hover{
				filter: drop-shadow(0 5px 10px #333);
				transform: scale3d(1.1, 1.1, 1.1); 
				transition: filter 1s, transform 1s, background-color .5s, color .5s, font-weight .5s;
				z-index: 4;
				cursor: pointer;
			}

			&.selected{
				font-weight: bold;
				background-color: #333;
				color: white;
			}
		}
	}

	.item{
		position: relative;
		border-radius: 30px;
		background-color: white;
		font-size: .5em;
		width: 90%;
		height: auto;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 1.5em;
		padding: 10px;

		text-align: center;
		transform: scale3d(1, 1, 1);
		filter: drop-shadow(0 3px 6px #333);
		transition: all .7s;
		overflow-x: hidden;

		&:hover{
			transform: scale3d(1.1, 1.1, 1.1);
			box-shadow: 0 6px 12px #333333ab;
			transition: all .7s;
			z-index: 2;
		}
	
		@media screen and (max-width: 425px){
			h2{
				font-size: 1em;
			}

			.tag{
				font-size: .8em;
			}
		}
	}

	h1, h2, h3, h4{
		color: #333;
	}

  .tag{
		font-size: 1em;
    filter: drop-shadow(0 2px 3px #333);
  }

	img{
		position: relative;
		z-index: 5;
		top: 1em;
		float: right;
		transition: filter .7s, transform .7s;
		transform: scale3d(1, 1, 1);
		filter: drop-shadow(0 1px 3px #333333a2);
	
		&:hover{
			transition: filter .7s, transform .7s;
			filter: drop-shadow(0 1px 4px #333333b7);
			transform: scale3d(1.2, 1.2, 1.2);
		}
	}
</style>